const accessoryItems = (state, action) => {
  if (action.activeTab !== state.activeTab) {
    return [];
  }
  return state.items;
};

const formatReceivedAccessories = (state, action) => [
  ...state.items,
  ...action.accessories.items.map((item) => ({
    ...item,
    itemUrl: `/accessories/${state.activeTab}/${item.name}`,
  })),
];

export const requestAccessories = (state, action) => ({
  ...state,
  isLoading: true,
  items: accessoryItems(state, action),
  activeTab: action.activeTab,
});

export const receiveAccessories = (state, action) => ({
  ...state,
  isLoading: false,
  items: formatReceivedAccessories(state, action),
  total: action.accessories.total,
});
